import React from "react";
import { inject, observer } from "mobx-react";
import withStyles from "react-jss";
import classNames from "classnames";
import Cookies from "js-cookie";
import loadable from "@loadable/component";
import userInfo from "Services/UserInfo";
import { sendMetriks } from "Services/sendMetriks";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import { CLICK_SEND_ORDER_OFFICE } from "Constants/metriks/Yandex";
import { SelectField } from "ComponentsUI/Selectfield";
import { PlaceholderInput } from "ComponentsUI/Placeholderinput";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import { PhoneMask, PositiveNumberMask } from "ComponentsUI/Masks";
import { CounterButton } from "ComponentsUI/Buttons";
import Button from "ComponentsUI/Button";
import AlertWrapper from "ComponentsUI/AlertWrapper";
import TermsOfUse from "ComponentsUI/TermsOfUse";

const AddressSearchHomeContainerB = loadable(
	() => import("Containers/AddressSearchHomeContainerB")
);

const styles = (theme) => ({
	root: {
		position: "relative",
	},
	placeholder: {
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.grayishBlue,
	},
	placeholderInput: {
		width: "100%",
	},
	blockHeader: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 1,
		letterSpacing: "2.3px",
		color: theme.palette.colors.darkSlateBlue,
		textTransform: "uppercase",
		width: "100%",
	},
	blockInput: {
		width: "100%",
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.veryDarkGray,
		marginTop: "17px",
		padding: "0 16px",
		backgroundColor: theme.palette.colors.transparent,
		appearance: "none",
		display: "flex",
		alignItems: "center",
		"&:focus": {
			backgroundColor: theme.palette.colors.white,
		},
	},
	blockInputIsError: {
		border: `solid 1px ${theme.palette.colors.coralPink}`,
	},
	blockInputTA: {
		height: "100px",
		resize: "none",
		paddingTop: "20px",
		paddingBottom: "20px",
	},
	block: {
		padding: "60px 300px",
		borderBottom: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
		"&:first-child": {
			paddingTop: 0,
		},
		"&:last-child": {
			borderBottom: "none",
		},
	},
	placeRadioGroupWrapper: {
		marginBottom: "45px",
		width: "100%",
	},
	placeRadioGroup: {
		marginTop: "27px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	radioGroupItem: {},
	radioGroupItemInput: {
		display: "none",
		"&:checked + $radioGroupItemLabel": {
			"& $radioGroupItemFakeInput": {
				border: `solid 7px ${theme.palette.colors.purplishBlue}`,
			},
			"& $radioGroupItemText": {
				color: theme.palette.colors.purplishBlue,
			},
		},
	},
	radioGroupItemLabel: {
		display: "flex",
		alignItems: "center",
		cursor: "pointer",
	},
	radioGroupItemFakeInput: {
		width: "30px",
		height: "30px",
		borderRadius: "50%",
		border: `solid 2px ${theme.palette.colors.cloudyBlue}`,
		marginRight: "14px",
		flexShrink: 0,
	},
	radioGroupItemText: {
		fontFamily: theme.fonts.medium,
		fontSize: "18px",
		lineHeight: 0.89,
		color: theme.palette.colors.oneMoreGrey,
		userSelect: "none",
	},
	placeAbout: {
		display: "flex",
		justifyContent: "space-between",
	},
	placeAboutFilterWrapper: {
		width: "280px",
	},
	aboutInputWrapper: {
		width: "180px",
		position: "relative",
		"& $blockInput": {
			paddingRight: "45px",
		},
		"& span": {
			position: "absolute",
			bottom: "17px",
			right: "18px",
			fontFamily: theme.fonts.light,
			fontSize: "16px",
			lineHeight: 1,
			color: theme.palette.colors.oneMoreGrey,
			"& sup": {
				fontSize: "12px",
			},
		},
	},
	aboutInputWrapperIsLong: {
		width: "200px",
	},
	placeCountOffices: {
		width: "180px",
		height: "50px",
		marginTop: "17px",
	},
	infoFullWrapper: {
		width: "100%",
		marginTop: "25px",
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "flex-start",
	},
	mergeLocalInput: {
		display: "none",
		"&:checked + $mergeLocal": {
			"& $mergeLocalFakeInput": {
				border: `1px solid ${theme.palette.colors.purplishBlue}`,
				backgroundColor: theme.palette.colors.purplishBlue,
				"& span": {
					display: "block",
				},
			},
		},
	},
	mergeLocal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
	},
	mergeLocalFakeInput: {
		width: "24px",
		height: "24px",
		border: `1px solid ${theme.palette.colors.oneMoreGrey}`,
		marginRight: "17px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& span": {
			fontSize: "14px",
			color: theme.palette.colors.white,
			display: "none",
		},
	},
	mergeLocalText: {
		fontFamily: theme.fonts.medium,
		fontSize: "18px",
		lineHeight: 1.11,
		color: theme.palette.colors.oneMoreGrey,
		userSelect: "none",
	},
	infoServicesWrapper: {
		marginBottom: "40px",
	},
	infoServicesList: {
		marginTop: "17px",
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		marginRight: "-20px",
	},
	infoServicesItem: {
		marginRight: "20px",
		marginBottom: "20px",
	},
	infoServicesItemInput: {
		display: "none",
		"&:checked + $infoServicesItemLabel": {
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
			"& $infoServicesItemText": {
				color: theme.palette.colors.purplishBlue,
			},
			"& $infoServicesItemFakeInput": {
				opacity: 1,
			},
		},
	},
	infoServicesItemLabel: {
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		display: "flex",
		alignItems: "center",
		height: "50px",
		padding: "0 20px",
		cursor: "pointer",
	},
	infoServicesItemText: {
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.oneMoreGrey,
		marginRight: "8px",
		userSelect: "none",
	},
	infoServicesItemFakeInput: {
		opacity: 0,
		marginTop: "5px",
		"& span": {
			color: theme.palette.colors.purplishBlue,
			fontSize: "24px",
		},
	},
	infoFiltersWrapper: {
		display: "flex",
		justifyContent: "space-between",
		marginBottom: "60px",
		flexWrap: "wrap",
	},
	infoFilterWrapper: {
		width: "280px",
	},
	infoRadioGroup: {
		"& $radioGroupItem": {
			marginBottom: "10px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},

	contactsContainer: {
		width: "100%",
		marginBottom: "27px",
		display: "flex",
		justifyContent: "space-between",
		flexWrap: "wrap",
	},

	contactsWrapper: {
		width: "280px",
		"& $placeholder": {
			top: "64%",
			paddingLeft: "17px",
		},
	},
	contactSearchStreet: {
		width: "500px",
		position: "relative",
	},
	contactsSearchStreetWrapper: {
		width: "100%",
		marginTop: "17px",
		display: "flex",
		justifyContent: "space-between",
		position: "relative",
	},
	contactsSearchStreetStreet: {
		width: "100%",
	},
	contactsDelete: {
		width: "60px",
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "absolute",
		bottom: 0,
		right: "-80px",
		fontSize: "35px",
		cursor: "pointer",
		userSelect: "none",
		"& span": {
			color: theme.palette.colors.lightGrayishViolet,
			fontSize: "16px",
		},
	},
	contactsAdd: {
		width: "60px",
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.purplishBlue}`,
		color: theme.palette.colors.purplishBlue,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "absolute",
		top: "16px",
		right: "-80px",
		fontSize: "35px",
		cursor: "pointer",
		userSelect: "none",
		lineHeight: 1,
	},
	contactsComment: {
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.oneMoreGrey,
		marginTop: "18px",
	},
	contactsContainerComment: {
		"& $placeholder": {
			top: "47px",
			paddingLeft: "20px",
		},
	},
	requiredStar: {
		color: "red",
	},
	hint: {
		marginTop: "30px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		block: {
			padding: "60px 160px",
		},
		placeAboutFilterWrapper: {
			width: "300px",
		},
		aboutInputWrapper: {
			width: "220px",
		},
		infoFilterWrapper: {
			width: "300px",
		},
		placeCountOffices: {
			width: "220px",
		},
		contactsWrapper: {
			width: "300px",
		},
		contactSearchStreet: {
			width: "540px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		blockHeader: {
			whiteSpace: "nowrap",
			fontSize: "14px",
			lineHeight: 1.14,
			letterSpacing: "2px",
		},
		block: {
			padding: "40px 60px",
		},
		radioGroupItemLabel: {},
		radioGroupItemFakeInput: {},
		radioGroupItemInput: {
			"&:checked + $radioGroupItemLabel": {
				"& $radioGroupItemFakeInput": {
					border: `solid 8px ${theme.palette.colors.purplishBlue}`,
				},
			},
		},
		placeCountOffices: {
			width: "170px",
		},
		placeAboutFilterWrapper: {
			width: "290px",
		},
		aboutInputWrapper: {
			width: "170px",
		},
		infoServicesList: {
			marginRight: "-10px",
		},
		infoServicesItem: {
			marginRight: "10px",
			marginBottom: "10px",
		},
		infoFilterWrapper: {
			width: "290px",
		},
		contactsWrapper: {
			width: "290px",
		},
		contactSearchStreet: {
			width: "530px",
		},
		contactsDelete: {
			width: "50px",
			right: "-60px",
		},
		contactsAdd: {
			width: "50px",
			right: "-60px",
		},
		aboutInputWrapperIsLong: {
			width: "200px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		blockHeader: {
			fontSize: "14px",
			lineHeight: 1.14,
			letterSpacing: "2px",
		},
		placeholder: {},
		blockInput: {
			height: "50px",
			fontSize: "16px",
			marginTop: "17px",
			padding: "0 20px",
		},
		block: {
			margin: "0 -20px",
			padding: "20px",
		},
		contactsDelete: {
			width: "16.66%",
			right: "0",
		},
		placeRadioGroupWrapper: {
			marginBottom: "40px",
		},
		radioGroupItem: {},
		placeRadioGroup: {
			marginTop: "17px",
			flexDirection: "column",
			alignItems: "flex-start",
			"& $radioGroupItem": {
				marginBottom: "10px",
				"&:last-child": {
					marginBottom: 0,
				},
			},
		},
		placeCountOffices: {
			width: "50%",
			height: "40px",
		},
		infoFullWrapper: {
			marginTop: "20px",
		},
		mergeLocal: {
			justifyContent: "flex-start",
		},
		mergeLocalFakeInput: {
			width: "20px",
			height: "20px",
			"& span": {
				fontSize: "12px",
			},
		},
		mergeLocalText: {
			fontSize: "16px",
			lineHeight: 1.25,
		},
		radioGroupItemFakeInput: {
			width: "20px",
			height: "20px",
			marginRight: "19px",
		},
		radioGroupItemLabel: {},
		radioGroupItemText: {},
		radioGroupItemInput: {
			"&:checked + $radioGroupItemLabel": {
				"& $radioGroupItemFakeInput": {
					border: `solid 5px ${theme.palette.colors.purplishBlue}`,
				},
			},
		},
		placeAbout: {
			flexWrap: "wrap",
		},
		placeAboutFilterWrapper: {
			width: "100%",
			marginBottom: "35px",
		},
		aboutInputWrapper: {
			width: "50%",
			position: "relative",
			"& span": {
				bottom: "16px",
			},
		},
		aboutInputWrapperIsLong: {
			width: "60%",
			marginBottom: "35px",
			"& + $placeAboutFilterWrapper": {
				marginBottom: 0,
			},
		},
		infoServicesWrapper: {
			marginBottom: "30px",
		},
		infoServicesList: {
			marginRight: "-10px",
		},
		infoServicesItem: {
			marginRight: "10px",
			marginBottom: "10px",
		},
		infoServicesItemInput: {
			display: "none",
		},
		infoServicesItemLabel: {
			height: "40px",
			padding: "0 15px",
		},
		infoServicesItemFakeInput: {
			"& span": {
				color: theme.palette.colors.purplishBlue,
				fontSize: "20px",
			},
		},
		infoFiltersWrapper: {
			justifyContent: "flex-start",
			marginBottom: "40px",
		},
		infoFilterWrapper: {
			width: "100%",
			"&:first-child": {
				marginBottom: "27px",
			},
		},
		infoRadioGroup: {
			"& $radioGroupItem": {
				marginBottom: "20px",
				"&:last-child": {
					marginBottom: 0,
				},
			},
			"& $radioGroupItemText": {
				fontSize: "16px",
				lineHeight: 1.13,
			},
		},
		contactsWrapper: {
			width: "100%",
			marginBottom: "27px",
			"& $placeholder": {
				top: "67%",
				paddingLeft: "21px",
			},
			"&:last-child": {
				marginBottom: 0,
			},
		},
		contactSearchStreet: {
			width: "100%",
		},
		contactsSearchStreetWrapper: {
			marginTop: "17px",
			justifyContent: "flex-start",
			flexWrap: "wrap",
		},
		contactsSearchStreetStreet: {
			width: "calc(100% - 16.66% - 10px)",
		},
		contactsAdd: {
			width: "16.66%",
			height: "50px",
			right: 0,
			fontSize: "35px",
			lineHeight: 1,
			cursor: "pointer",
		},
		contactsComment: {
			fontSize: "14px",
			lineHeight: 1.29,
		},
		blockInputTA: {
			height: " 100px",
		},
	},
});

@inject("ApplicationModel")
@observer
class Tender extends React.Component {
	static defaultProps = {
		radioButtonsForPlace: [],
		services: [],
		sendData: () => {},
		radioButtonsForInfo: [],
		selectedOptionPlace: 0,
	};

	constructor(props) {
		super(props);
		this.state = {
			error: false,
			counterAdresses: 1,
			counterFullAdresses: 1,
			selectedOptionPlace: props.selectedOptionPlace,
			selectedOptionExistInfo: 0,
			services: this.props.services,
			selectTypeOfTechnologies: [],
			selectTypeOfBuilding: [],
			selectTypeOfHouse: [],
			area: ``,
			areaOfBuilding: ``,
			nameOfCompany: "",
			siteOfCompany: "",
			contactPerson: "",
			phone: props.phone,
			email: "",
			comment: "",
			speed: [],
			countOfOffices: 0,
			mergeToLocal: true,
			focusingInput: 0,
			firstClickPhoneInput: true,
			lastClickPhoneInput: true,
		};
		this.errorText = props.text.TENDER_ERROR;
	}
	inputRef = null;

	// Поставить авфтофокус на инпуте, если он не ставился и его нужно установить
	componentDidUpdate(prevProps, prevState, snapshot) {
		let prevPropsWindowSizes = prevProps.windowSizes;
		let windowSizes = this.props.windowSizes;
		let inputRef = this.inputRef;
		if (
			!this.state.focusingInput &&
			inputRef &&
			(windowSizes?.md || windowSizes?.lg) &&
			(prevPropsWindowSizes?.md || prevPropsWindowSizes?.lg)
		) {
			inputRef.focus();
			this.changeStateFocusInput();
		} else if (!this.state.focusingInput && inputRef && (windowSizes.xs || windowSizes?.sm)) {
			this.changeStateFocusInput();
		}
	}

	changeStateFocusInput() {
		this.setState({ focusingInput: 1 });
	}

	removeAdressInput(i) {
		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		if (one_string_search) {
			this.setState({
				counterFullAdresses: this.state.counterFullAdresses - 1,
			});
			this.props.tenderOneStringModel.removeSearchModel(i);
		} else {
			this.setState({
				counterAdresses: this.state.counterAdresses - 1,
			});
			this.props.tenderModel.removeSearcheModel(i);
		}
	}

	generateAddresesInput() {
		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		let array = [];
		let classes = this.props.classes;

		if (one_string_search) {
			for (let i = 0; i < this.state.counterFullAdresses; i++) {
				array.push(
					<div key={i} className={classes.contactsSearchStreetWrapper}>
						<div
							className={classes.contactsSearchStreetStreet}
							data-update={`${
								this.props.searchOneStringModels[i].getCurrentFullAddress().data?.street_id
							}`}
							style={{
								zIndex: (this.state.counterFullAdresses - i) * 10 - 1,
							}}
						>
							<AddressSearchHomeContainerB
								tender={true}
								withoutReset={true}
								layoutB={true}
								datatest={"business_order_input_street"}
								withoutContainer={true}
								withoutSwitcher={true}
								withoutButton={true}
								onEnterHandler={() => {}}
								error={
									this.state.error && this.addressValidation(this.props.searchOneStringModels[i])
								}
								searcheModel={this.props.seacheModels[0]}
								searchOneStringModel={this.props.searchOneStringModels[i]}
							/>
						</div>
						{!!i && (
							<div className={classes.contactsDelete} onClick={() => this.removeAdressInput(i)}>
								<span className="icon24 icon-close" />
							</div>
						)}
					</div>
				);
			}
		} else {
			for (let i = 0; i < this.state.counterAdresses; i++) {
				array.push(
					<div key={i} className={classes.contactsSearchStreetWrapper}>
						<div
							className={classes.contactsSearchStreetStreet}
							data-update={`${this.props.seacheModels[i].getCurrentStreet().id}`}
							style={{
								zIndex: (this.state.counterAdresses - i) * 10 - 1,
							}}
						>
							<AddressSearchHomeContainerB
								tender={true}
								withoutReset={true}
								layoutB={true}
								datatest={"business_order_input_street"}
								withoutContainer={true}
								withoutSwitcher={true}
								withoutButton={true}
								onEnterHandler={() => {}}
								error={this.state.error && this.addressValidation(this.props.seacheModels[i])}
								searcheModel={this.props.seacheModels[i]}
								searchOneStringModel={this.props.searchOneStringModels[0]}
							/>
						</div>
						{!!i && (
							<div className={classes.contactsDelete} onClick={() => this.removeAdressInput(i)}>
								<span className="icon24 icon-close" />
							</div>
						)}
					</div>
				);
			}
		}

		return array;
	}

	increaseCounterOfAdresses() {
		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		if (one_string_search) {
			if (this.state.counterFullAdresses < 5) {
				this.setState({
					counterFullAdresses: this.state.counterFullAdresses + 1,
				});

				this.props.tenderOneStringModel.addSearchModel();
			}
		} else {
			if (this.state.counterAdresses < 5) {
				this.setState({
					counterAdresses: this.state.counterAdresses + 1,
				});

				this.props.tenderModel.addSearcheModel();
			}
		}
	}

	setSelectedOptionPlace(index) {
		this.setState({
			selectedOptionPlace: index,
		});
	}

	changeServices(index) {
		let services = this.state.services;
		services[index].checked = !services[index].checked;
		this.setState({
			services: services,
		});
	}

	setSelectedOptionExistInfo(index) {
		this.setState({
			selectedOptionExistInfo: index,
		});
	}

	changeState(value, item) {
		this.setState({ [value]: item });
	}

	generateRadioButtons(data, name, compareValue, onChangeHandler) {
		let classes = this.props.classes;
		return data.map((item, index) => {
			return (
				<div key={index} className={classes.radioGroupItem}>
					<input
						name={name}
						id={name + index}
						type="radio"
						value={index}
						className={classes.radioGroupItemInput}
						checked={compareValue == index}
						onChange={() => onChangeHandler(index)}
					/>
					<label
						htmlFor={name + index}
						className={classes.radioGroupItemLabel}
						datatest={item.datatest}
					>
						<div className={classes.radioGroupItemFakeInput} />
						<div className={classes.radioGroupItemText}>{item.name}</div>
					</label>
				</div>
			);
		});
	}

	generateServices() {
		let classes = this.props.classes;
		return this.state.services.map((item, index) => {
			return (
				<div key={index} className={classes.infoServicesItem}>
					<input
						id={"tender__services" + index}
						type="checkbox"
						value={index}
						className={classes.infoServicesItemInput}
						checked={item.checked}
						onChange={() => this.changeServices(index)}
					/>
					<label
						htmlFor={"tender__services" + index}
						className={classes.infoServicesItemLabel}
						datatest={item.datatest}
					>
						<div className={classes.infoServicesItemText}>{item.name}</div>
						<div className={classes.infoServicesItemFakeInput}>
							<span className="icon24 icon-check" />
						</div>
					</label>
				</div>
			);
		});
	}

	addressValidation(searchModel) {
		return searchModel.checkErrors();
	}

	setError() {
		Metrika.getInstance().google.sendEvent(EVENT_CATEGORY_CLICK_BUTTON, "click_error_request");
		this.setState({
			error: true,
		});
	}

	sendForm(event) {
		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		event.preventDefault();
		event.stopPropagation();
		let services = this.state.services.filter((item, index) => {
			if (item.checked) return true;
			return false;
		});

		services = services.map((item, index) => {
			return item.name;
		});

		let fullAddresses;

		if (one_string_search) {
			fullAddresses = this.props.searchOneStringModels
				.map((item) => {
					if (!item.checkErrorsTender()) {
						let fullAddress = item.getCurrentFullAddress();
						let district_name = fullAddress.data?.district_name || "";

						return `${district_name} ${item.searcheForm.fields.fullAddress.value}`;
					}
					return null;
				})
				.filter((item) => !!item);
		} else {
			fullAddresses = this.props.tenderModel.seacheModels
				.map((item, index) => {
					if (!item.checkErrors()) {
						let street = item.getCurrentStreet();
						return `${street.district} ${street.full} ${item.searcheForm.fields.address.value}`;
					}
					return null;
				})
				.filter((item) => !!item);
		}

		fullAddresses = fullAddresses.join("; ");

		let data;

		if (one_string_search) {
			let correctSearchModel = this.props.searchOneStringModels.find(
				(item) => !item.checkErrorsTender()
			);

			const fullAddress = correctSearchModel.getCurrentFullAddress();

			data = {
				phone_connection: this.state.phone,
				type_connection: this.state.selectedOptionPlace,
				office_square: this.state.selectedOptionPlace == 0 ? this.state.area : 0,
				why_change: this.state.selectedOptionExistInfo,
				office_location:
					this.state.selectTypeOfBuilding.length > 0 && this.state.selectedOptionPlace == 0
						? this.state.selectTypeOfBuilding[0].id
						: 0,
				cnt_offices: this.state.selectedOptionPlace == 1 ? this.state.countOfOffices : 0,
				network_office: this.state.mergeToLocal ? 0 : 1,
				connected_office: this.state.selectedOptionExistInfo,
				building_square: this.state.selectedOptionPlace == 2 ? this.state.areaOfBuilding : 0,
				type_offices:
					this.state.selectTypeOfHouse.length > 0 && this.state.selectedOptionPlace == 2
						? this.state.selectTypeOfHouse[0].id
						: null,
				services: services,
				contact_locality: this.props.region && this.props.region.name,
				region: fullAddress?.data?.region_name || "",
				region_id: this.props.region.id || fullAddress?.data?.region_id,
				district: fullAddress?.data?.district_name || "",
				district_id: fullAddress?.data?.district_id || null,
				street: fullAddress?.data?.street_full || "",
				street_id: fullAddress?.data?.street_id || null,
				one_string_search: 1,
				house: fullAddress?.data?.house || "",
				house_id: fullAddress?.data?.address_id || null,
				addresses: fullAddresses,
				title_company: this.state.nameOfCompany,
				website: this.state.siteOfCompany,
				fio: this.state.contactPerson,
				email: this.state.email,
				technology:
					this.state.selectTypeOfTechnologies.length > 0
						? this.state.selectTypeOfTechnologies[0].id
						: 4,
				info: this.state.comment,
				canal_speed:
					!!this.state.speed && this.state.speed.length > 0 ? this.state.speed[0].id : null,
				utm_campaign: Cookies.get("utm_campaign"),
				utm_medium: Cookies.get("utm_medium"),
				utm_source: Cookies.get("utm_source"),
				utm_content: Cookies.get("utm_content"),
				utm_term: Cookies.get("utm_term"),
			};

			Metrika.getInstance().yandex.sendEvent(
				YANDEX_TARGETS.CLICK_SEND_OFFICE_BUTTON_NEW_SEARCH,
				[]
			);
		} else {
			let correctSearchModel = this.props.seacheModels.find((item) => !item.checkErrors());

			data = {
				phone_connection: this.state.phone,
				type_connection: this.state.selectedOptionPlace,
				office_square: this.state.selectedOptionPlace == 0 ? this.state.area : 0,
				why_change: this.state.selectedOptionExistInfo,
				office_location:
					this.state.selectTypeOfBuilding.length > 0 && this.state.selectedOptionPlace == 0
						? this.state.selectTypeOfBuilding[0].id
						: 0,
				cnt_offices: this.state.selectedOptionPlace == 1 ? this.state.countOfOffices : 0,
				network_office: this.state.mergeToLocal ? 0 : 1,
				connected_office: this.state.selectedOptionExistInfo,
				building_square: this.state.selectedOptionPlace == 2 ? this.state.areaOfBuilding : 0,
				type_offices:
					this.state.selectTypeOfHouse.length > 0 && this.state.selectedOptionPlace == 2
						? this.state.selectTypeOfHouse[0].id
						: null,
				services: services,
				contact_locality: this.props.region && this.props.region.name,
				street: correctSearchModel.searcheForm.fields.street.value,
				street_id: correctSearchModel.getCurrentStreet().id,
				house: correctSearchModel.searcheForm.fields.address.value,
				house_id:
					!!correctSearchModel.getCurrentAddress().id &&
					correctSearchModel.getCurrentAddress().id !== -1
						? correctSearchModel.getCurrentAddress().id
						: null,
				addresses: fullAddresses,
				title_company: this.state.nameOfCompany,
				website: this.state.siteOfCompany,
				fio: this.state.contactPerson,
				email: this.state.email,
				technology:
					this.state.selectTypeOfTechnologies.length > 0
						? this.state.selectTypeOfTechnologies[0].id
						: 4,
				info: this.state.comment,
				canal_speed:
					!!this.state.speed && this.state.speed.length > 0 ? this.state.speed[0].id : null,
				region_id: this.props.region.id,
				utm_campaign: Cookies.get("utm_campaign"),
				utm_medium: Cookies.get("utm_medium"),
				utm_source: Cookies.get("utm_source"),
				utm_content: Cookies.get("utm_content"),
				utm_term: Cookies.get("utm_term"),
			};

			Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_SEND_OFFICE_BUTTON, []);
		}

		let info = [
			`Место подключения - ${this.props.radioButtonsForPlace[this.state.selectedOptionPlace].name}`,
			this.state.selectedOptionPlace === 0
				? `Площадь офиса - ${!!this.state.area ? this.state.area : 0}м`
				: null,
			this.state.selectTypeOfBuilding.length > 0 && this.state.selectedOptionPlace === 0
				? `Тип офиса - ${this.state.selectTypeOfBuilding[0].name}`
				: null,
			this.state.selectedOptionPlace === 1 ? `Кол-во офисов - ${this.state.countOfOffices}` : null,
			this.state.selectedOptionPlace === 2 ? `Площадь здания - ${this.state.areaOfBuilding}` : null,
			this.state.selectTypeOfHouse.length > 0 && this.state.selectedOptionPlace === 2
				? `Тип офиса - ${this.state.selectTypeOfHouse[0].name}`
				: null,
			`Сервисы - ${services.join(", ")}`,
			`Регион - ${this.props.region && this.props.region.name}`,
			`Почему меняют провайдера - ${
				this.props.radioButtonsForInfo[this.state.selectedOptionExistInfo].name
			}`,
			this.state.selectTypeOfTechnologies.length > 0
				? `Технология - ${this.state.selectTypeOfTechnologies[0].name}`
				: null,
			!!this.state.speed && this.state.speed.length > 0
				? `Скорость - ${this.state.speed[0].name}`
				: null,
			this.state.comment,
		];
		data.info = info.filter((item) => !!item).join("&&&");
		data.lead_form_type = userInfo(CLICK_SEND_ORDER_OFFICE);
		// Metrika.getInstance().google.sendEvent(
		//     EVENT_CATEGORY_ORDER,
		//     EVENT_ACTION_CLICK_SEND_ORDER_OFFICE
		// );
		sendMetriks("CLICK_SEND_ORDER_OFFICE");
		sendMetriks("LEAD_ALL");
		this.props.sendData(data);
	}

	validateForm() {
		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		if (!this.state.contactPerson || !this.props.validatePhone(this.state.phone)) {
			return false;
		}

		let findCorrectModel = false;

		if (one_string_search) {
			for (let i = 0; i < this.state.counterFullAdresses; i++) {
				if (!this.props.searchOneStringModels[i].checkErrorsTender()) {
					findCorrectModel = true;
				}
			}
		} else {
			for (let i = 0; i < this.state.counterAdresses; i++) {
				if (!this.props.seacheModels[i].checkErrors()) {
					findCorrectModel = true;
				}
			}
		}

		if (!findCorrectModel) {
			return false;
		}

		if (this.state.error) {
			this.setState({
				error: false,
			});
		}

		return true;
	}

	render() {
		let text = this.props.text;
		let classes = this.props.classes;
		let typeBuilding = [
			{
				name: text.TENDER_BUILDING_BUSINESS_CENTER,
				id: 0,
			},
			{
				name: text.TENDER_BUILDING_HOUSE,
				id: 1,
			},
			{
				name: text.TENDER_BUILDING_OWN,
				id: 2,
			},
			{
				name: text.TENDER_BUILDING_TRADE_CENTER,
				id: 3,
			},
			{
				name: text.TENDER_BUILDING_OTHER,
				id: 4,
			},
		];

		let typeHouses = [
			{
				name: text.TENDER_TYPE_FLAT_OFFICE,
				id: 0,
			},
			{
				name: text.TENDER_TYPE_FLAT_HOME,
				id: 1,
			},
			{
				name: text.TENDER_TYPE_FLAT_SHOP,
				id: 2,
			},
			{
				name: text.TENDER_TYPE_FLAT_OTHER,
				id: 3,
			},
		];

		let typeTechnologies = [
			{
				name: text.TECH_LTE,
				id: 0,
			},
			{
				name: text.TECH_ADSL,
				id: 1,
			},
			{
				name: text.TECH_ETHERNET,
				id: 2,
			},
			{
				name: text.TECH_OPTICAL,
				id: 3,
			},
		];

		let typeSpeeds = [
			{
				name: text.TENDER_SPEED_1,
				id: 0,
			},
			{
				name: text.TENDER_SPEED_2,
				id: 2,
			},
			{
				name: text.TENDER_SPEED_3,
				id: 4,
			},
			{
				name: text.TENDER_SPEED_4,
				id: 1,
			},
			{
				name: text.TENDER_SPEED_5,
				id: 3,
			},
			{
				name: text.TENDER_SPEED_6,
				id: 5,
			},
		];

		let disableButton = !this.validateForm();

		let one_string_search =
			this.props.ApplicationModel?.siteConfig?.settings?.one_string_search?.enabled;

		return (
			<form className={classes.root}>
				<Container>
					<Row>
						<Col xs={12}>
							<div className={classes.block}>
								<div className={classes.contactsContainer}>
									<div className={classes.blockHeader}>
										{text.CONTANT_PERSON}
										<span className={classes.requiredStar}>*</span>
									</div>
									<input
										ref={(ref) => {
											this.inputRef = ref;
										}}
										autoComplete="name"
										name="name"
										type="text"
										maxLength={100}
										datatest="business_order_input_person"
										className={classNames(classes.blockInput, {
											[classes.blockInputIsError]: this.state.error && !this.state.contactPerson,
										})}
										value={this.state.contactPerson}
										onChange={(event) => {
											this.changeState(`contactPerson`, event.currentTarget.value);
										}}
									/>
								</div>
								<div className={classes.contactsContainer}>
									<div className={classes.contactsWrapper}>
										<div className={classes.blockHeader}>
											{text.callbackPhone}
											<span className={classes.requiredStar}>*</span>
										</div>
										<PlaceholderInput
											className={classes.placeholderInput}
											classNamePlaceholder={classes.placeholder}
											placeholder="+7"
											value={this.state.phone}
										>
											<PhoneMask
												autocomplete="tel"
												name="tel"
												datatest="business_order_input_tel"
												className={classNames(classes.blockInput, {
													[classes.blockInputIsError]:
														this.state.error && !this.props.validatePhone(this.state.phone),
												})}
												changeCallback={(value) => {
													if (value.length === 1 && this.state.firstClickPhoneInput) {
														sendMetriks("CLICK_PHONE");
														this.changeState(`firstClickPhoneInput`, false);
													}
													if (value.length === 11 && this.state.lastClickPhoneInput) {
														sendMetriks("ENTER_NUMBER");
														this.changeState(`lastClickPhoneInput`, false);
													}
													this.changeState(`phone`, value);
												}}
											/>
										</PlaceholderInput>
									</div>
									<div className={classes.contactsWrapper}>
										<div className={classes.blockHeader}>{text.subscribeEmail}</div>
										<input
											placeholder="Для предложений"
											autoComplete="email"
											name="email"
											type="text"
											maxLength={100}
											datatest="business_order_input_email"
											className={classes.blockInput}
											value={this.state.email}
											onChange={(event) => {
												this.changeState(`email`, event.currentTarget.value);
											}}
										/>
									</div>
								</div>
								<div className={classes.contactsContainer}>
									<div className={classes.blockHeader}>
										{text.ADDRESS_OF_CONNECTION}
										<span className={classes.requiredStar}>*</span>
									</div>
									<div className={classes.contactSearchStreet}>
										{this.generateAddresesInput()}
										{this.state.counterAdresses < 5 && (
											<div
												className={classNames(classes.contactsAdd, {
													[classes.hint]: !!one_string_search,
												})}
												onClick={() => this.increaseCounterOfAdresses()}
											>
												{" "}
												+
											</div>
										)}
									</div>
									<div className={classes.contactsComment}>{text.BUSINESS_TENDER_ADD_ADDRESS}</div>
								</div>
								<AlertWrapper error={this.state.error && this.errorText}>
									<Button
										datatest="business_order_tenderbbutton"
										onClick={(event) => {
											disableButton ? this.setError() : this.sendForm(event);
										}}
										fullWidth={true}
										noPaddings={true}
										size="middle"
										disabled={disableButton}
										status="purple"
									>
										{text.SEND_TENDER}
									</Button>
								</AlertWrapper>
								<TermsOfUse buttonText={text.SEND_TENDER} isTender={true} />
								<div className={classes.contactsComment}>
									{text.BUSINESS_TENDER_ADDITIONAL_TEXT}
								</div>
							</div>

							<div className={classes.block}>
								<div className={classes.placeRadioGroupWrapper}>
									<div className={classes.blockHeader}>{text.PLACE_OF_CONNECTION}</div>
									<div className={classes.placeRadioGroup}>
										{this.generateRadioButtons(
											this.props.radioButtonsForPlace,
											"tender_place",
											this.state.selectedOptionPlace,
											(index) => this.setSelectedOptionPlace(index)
										)}
									</div>
								</div>
								{this.state.selectedOptionPlace == 0 && (
									<div className={classes.placeAbout}>
										<div className={classes.placeAboutFilterWrapper}>
											<SelectField
												multiselect={false}
												windowSizes={this.props.windowSizes}
												items={typeBuilding}
												findItems={this.state.selectTypeOfBuilding}
												onItemSelect={(items) => this.changeState(`selectTypeOfBuilding`, items)}
												text={text}
												title={text.TYPE_OF_RESIDENT}
											/>
										</div>
										<div className={classes.aboutInputWrapper}>
											<div className={classes.blockHeader}>{text.SQUARE_OF_OFFICE}</div>
											<PositiveNumberMask
												type="number"
												className={classNames(classes.blockInput)}
												value={this.state.area}
												changeCallback={(value) => {
													this.changeState(`area`, value);
												}}
											/>
											<span>
												{text.METERS_LOW}
												<sup>2</sup>
											</span>
										</div>
									</div>
								)}
								{this.state.selectedOptionPlace == 1 && (
									<div>
										<div className={classes.blockHeader}>{text.OFFICE_AMOUNT}</div>
										<div className={classes.placeCountOffices}>
											<CounterButton
												changeCallback={(value) => {
													this.changeState(`countOfOffices`, value);
												}}
											/>
										</div>
									</div>
								)}
								{this.state.selectedOptionPlace == 2 && (
									<div className={classes.placeAbout}>
										<div
											className={classNames(
												classes.aboutInputWrapper,
												classes.aboutInputWrapperIsLong
											)}
										>
											<div className={classes.blockHeader}>{text.SQUARE_OF_BUILDING}</div>
											<PositiveNumberMask
												type="number"
												datatest="business_order_input_metricarea"
												className={classes.blockInput}
												value={this.state.areaOfBuilding}
												changeCallback={(value) => {
													this.changeState(`areaOfBuilding`, value);
												}}
											/>
											<span>
												{text.METERS_LOW}
												<sup>2</sup>
											</span>
										</div>
										<div className={classes.placeAboutFilterWrapper}>
											<SelectField
												windowSizes={this.props.windowSizes}
												items={typeHouses}
												datatest="business_order_input_roomtype"
												onItemSelect={(items) => this.changeState(`selectTypeOfHouse`, items)}
												text={text}
												findItems={this.state.selectTypeOfHouse}
												title={text.TYPE_OF_BUILDING}
											/>
										</div>
									</div>
								)}
							</div>
							<div className={classes.block}>
								<div className={classes.infoServicesWrapper}>
									<div className={classes.blockHeader}>{text.SERVICES}</div>
									<div className={classes.infoServicesList}>{this.generateServices()}</div>
								</div>
								{this.state.services[0].checked && (
									<div className={classes.infoFiltersWrapper}>
										<div className={classes.infoFilterWrapper}>
											<SelectField
												windowSizes={this.props.windowSizes}
												datatest="business_order_input_internetspeed"
												items={typeSpeeds}
												onItemSelect={(items) => this.changeState(`speed`, items)}
												text={text}
												placeholder={text.EVERYTHING_3}
												findItems={this.state.speed}
												title={text.FILTERS_SPEED}
											/>
										</div>
										<div className={classes.infoFilterWrapper}>
											<SelectField
												windowSizes={this.props.windowSizes}
												items={typeTechnologies}
												datatest="business_order_input_technology"
												onItemSelect={(items) =>
													this.changeState(`selectTypeOfTechnologies`, items)
												}
												text={text}
												placeholder={text.EVERYTHING_3}
												findItems={this.state.selectTypeOfTechnologies}
												title={text.TECHNOLOGY}
											/>
										</div>
										{this.state.selectedOptionPlace == 1 && (
											<div className={classes.infoFullWrapper}>
												<input
													id="mergeLocal"
													type="checkbox"
													checked={this.state.mergeToLocal}
													className={classes.mergeLocalInput}
													onChange={() => {
														this.changeState(`mergeToLocal`, !this.state.mergeToLocal);
													}}
												/>
												<label className={classes.mergeLocal} htmlFor="mergeLocal">
													<div className={classes.mergeLocalFakeInput}>
														<span className="icon24 icon-check" />
													</div>
													<div className={classes.mergeLocalText}>{text.COMBINE_OFFICES}</div>
												</label>
											</div>
										)}
									</div>
								)}
								<div className={classes.infoRadioGroup}>
									{this.generateRadioButtons(
										this.props.radioButtonsForInfo,
										"tender_info",
										this.state.selectedOptionExistInfo,
										(index) => this.setSelectedOptionExistInfo(index)
									)}
								</div>
							</div>
							<div className={classes.block}>
								<div className={classes.contactsContainer}>
									<div className={classes.blockHeader}>{text.NAME_OF_ORGANIZATION}</div>
									<input
										autoComplete="organization"
										name="organization"
										type="text"
										datatest="business_order_input_nameorg"
										className={classNames(classes.blockInput)}
										value={this.state.nameOfCompany}
										maxLength={100}
										onChange={(event) => {
											this.changeState(`nameOfCompany`, event.currentTarget.value);
										}}
									/>
								</div>
								<div className={classes.contactsContainer}>
									<div className={classes.contactsWrapper}>
										<div className={classes.blockHeader}>{text.WEBSITE}</div>
										<PlaceholderInput
											className={classes.placeholderInput}
											placeholder={text.NOT_REQUIRE}
											classNamePlaceholder={classes.placeholder}
										>
											<input
												type="text"
												maxLength={100}
												datatest="business_order_input_site"
												className={classes.blockInput}
												value={this.state.siteOfCompany}
												onChange={(event) => {
													this.changeState(`siteOfCompany`, event.currentTarget.value);
												}}
											/>
										</PlaceholderInput>
									</div>
								</div>
								<div
									className={classNames(
										classes.contactsContainer,
										classes.contactsContainerComment
									)}
								>
									<div className={classes.blockHeader}>{text.COMMENT}</div>
									<PlaceholderInput
										className={classes.placeholderInput}
										placeholder={text.NOT_REQUIRE}
										classNamePlaceholder={classes.placeholder}
									>
										<textarea
											type="text"
											datatest="business_order_input_comment"
											className={classNames(classes.blockInput, classes.blockInputTA)}
											value={this.state.comment}
											onChange={(event) => {
												this.changeState(`comment`, event.currentTarget.value);
											}}
										/>
									</PlaceholderInput>
								</div>
								<AlertWrapper error={this.state.error && this.errorText}>
									<Button
										datatest="business_order_tenderbbutton"
										onClick={(event) => {
											disableButton ? this.setError() : this.sendForm(event);
										}}
										fullWidth={true}
										noPaddings={true}
										size="middle"
										disabled={disableButton}
										status="purple"
									>
										{text.SEND_TENDER}
									</Button>
								</AlertWrapper>
								<TermsOfUse buttonText={text.SEND_TENDER} isTender={true} />
							</div>
						</Col>
					</Row>
				</Container>
			</form>
		);
	}
}

export default withStyles(styles)(Tender);
